import { render, staticRenderFns } from "./knowlarityHistory.vue?vue&type=template&id=740420ac&scoped=true&"
import script from "./knowlarityHistory.vue?vue&type=script&lang=js&"
export * from "./knowlarityHistory.vue?vue&type=script&lang=js&"
import style0 from "./knowlarityHistory.vue?vue&type=style&index=0&id=740420ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740420ac",
  null
  
)

export default component.exports